const getGaClientIdFromDataLayer = () => {
  const dataLayer = window.dataLayer || [];

  if (!Array.isArray(dataLayer)) {
    return null;
  }

  const latestEntryWithClientId = [...dataLayer].reverse().find((entry) => entry && entry.ga_client_id);
  return latestEntryWithClientId ? latestEntryWithClientId.ga_client_id : null;
};

const getGaClientIdFromCookie = () => {
  const match = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.(\d+\.\d+)/);
  return match ? match[1] : null;
};

const getGaClientId = (callback) => {
  const clientId = getGaClientIdFromDataLayer() || getGaClientIdFromCookie();

  if (callback) {
    callback(clientId);
  }

  return clientId;
};

export default getGaClientId;
